import axios from "axios";
const API_URL = "/api/v2/file-rename-jobs";
const API_V2_URL = "/api/v2/file-rename-jobs";

export const getFileRenameJobs = (statuses = []) => {
  let url = API_URL;
  let queryString = "";

  statuses.forEach((status) => {
    queryString += `&status=${status}`;
  });

  return axios.get(`${url}?${queryString}`);
};

export const createFileRenameJob = (data) => {
  return axios.post(API_URL, data);
};

export const getFileRenameJob = (id) => {
  return axios.get(`${API_URL}/${id}`);
};

export const updateFileRenameJob = (id, data) => {
  return axios.patch(`${API_URL}/${id}/update`, data);
};

export const rerunAiFileRename = (id, payload) => {
  return axios.post(`${API_URL}/${id}/rerun-ai`, payload);
};

export function uploadFilesToFileRenameJobSection(id, sectionId, files) {
  const filesToRegister = files.map((file) => ({
    fileName: file.name,
    extension: file.name.split(".").pop(),
    contentType: file.type,
  }));

  return axios.post(`${API_URL}/${id}/${sectionId}/upload-file`, {
    files: filesToRegister,
  });
}

export function downloadAllFilesForJob(id) {
  return axios.get(`${API_V2_URL}/${id}/bulk-download?pdf=true`, {
    baseURL: import.meta.env.VITE_SCHEDULER_URL,
  });
}

export const deleteFileRenameJob = (id) => {
  return axios.delete(`${API_URL}/${id}`);
};
